import styles from './styles/eligibilitySummaryCard.module.scss';

export const STATUS_CONFIG = {
    low: {
        text: 'Stable',
        className: styles.reliabilityBadgeHigh,
    },
    medium: {
        text: 'Medium',
        className: styles.reliabilityBadgeMedium,
    },
    high: {
        text: 'High',
        className: styles.reliabilityBadgeLow,
    },
};